import React, { useEffect, useState } from 'react'
import { router } from '@inertiajs/react'
import { v4 as uuid } from 'uuid'
import { Popup, ToolbarItem } from 'devextreme-react/popup'
import Button from 'devextreme-react/button'
import { useTranslation } from 'react-i18next'

const channel = new BroadcastChannel('tab-communication-channel')
const tabId = 'tab-' + uuid()

export const UniqueTab = () => {
  const { t } = useTranslation()
  const [blocked, setBlocked] = useState(false)

  useEffect(() => {
    channel.onmessage = (event) => {
      if (event.data.type) {
        switch (event.data.type) {
          case 'new_url_visited': {
            const myUri = window.location.pathname
            const newUri = new URL(window.origin + event.data.url).pathname

            if (tabId !== event.data.tab_id && myUri === newUri) {
              setBlocked(true)
            }
            break
          }
        }
      }
    }

    const removeListenerCallback = router.on('navigate', (event) => {
      try {
        channel.postMessage({ type: 'new_url_visited', url: event.detail.page.url, tab_id: tabId })
      } catch (error) {
        // "Failed to execute 'postMessage' on 'BroadcastChannel': Channel is closed."
      }
    })

    return () => {
      removeListenerCallback()
      channel.close()
    }
  }, [])

  if (blocked) {
    return (
      <Popup
        width={800}
        height='auto'
        visible
        animation={null}
        title={t('messages.same_page_opened_in_new_tab')}
        wrapperAttr={{
          class: 'add-new-popup-wrap'
        }}
      >
        {t('messages.same_page_opened_in_new_tab_message')}

        <ToolbarItem
          toolbar='bottom'
          location='before'
          cssClass='popup-footer-wrap'
        >
          <Button
            onClick={() => {
              setBlocked(false)
            }}
            stylingMode='contained'
            text={t('labels.continue_with_work')}
          />
        </ToolbarItem>
      </Popup>
    )
  }

  return null
}
